export const SET_COMMON_LOADING = 'SET_COMMON_LOADING'
export const RESET_COMMON_LOADING = 'RESET_COMMON_LOADING'
export const SET_COMMON_LOADING_TIMER_ID = 'SET_COMMON_LOADING_TIMER_ID'
export const RESET_COMMON_LOADING_TIMER_ID = 'RESET_COMMON_LOADING_TIMER_ID'
export const SET_COMMON_HEADER_MENU_OPEN = 'SET_COMMON_HEADER_MENU_OPEN'
export const SET_USER = 'SET_USER'
export const UPDATE_USER_TOKEN = 'UPDATE_USER_TOKEN'
export const SET_USER_EMAIL_VERIFIED = 'SET_USER_EMAIL_VERIFIED'
export const START_LEARNING = 'START_LEARNING'
export const PREPARE_LEARNING = 'PREPARE_LEARNING'
export const FINISH_LEARNING = 'FINISH_LEARNING'
export const SET_LEARNING_CURRENT_ANSWER_ID = 'SET_LEARNING_CURRENT_ANSWER_ID'
export const START_LEARNING_CURRENT = 'START_LEARNING_CURRENT'
export const RESET_LEARNING_CURRENT = 'RESET_LEARNING_CURRENT'
export const SET_ADMIN_USER = 'SET_ADMIN_USER'
export const SET_ADMIN_USER_TOKENS = 'SET_ADMIN_USER_TOKENS'
export const SET_ADMIN_USER_ALLOWED_SERVICE_IDS = 'SET_ADMIN_USER_ALLOWED_SERVICE_IDS'
export const SET_CATEGORY_ITEMS = 'SET_CATEGORY_ITEMS'
// For User Post
export const SET_POST_LIST = 'SET_POST_LIST'
export const PUSH_ITEM_TO_POSTS_PAGER_KEYS = 'PUSH_ITEM_TO_POSTS_PAGER_KEYS'
export const RESET_POSTS_PAGER = 'RESET_POSTS_PAGER'
export const SET_POSTS_PAGER_LAST_INDEX = 'SET_POSTS_PAGER_LAST_INDEX'
export const SET_POSTS_PAGER_PARAMS = 'SET_POSTS_PAGER_PARAMS'
// For Adimin Post
export const SET_ADMIN_POST_LIST = 'SET_ADMIN_POST_LIST'
export const PUSH_ITEM_TO_ADMIN_POSTS_PAGER_KEYS = 'PUSH_ITEM_TO_ADMIN_POSTS_PAGER_KEYS'
export const RESET_ADMIN_POSTS_PAGER = 'RESET_ADMIN_POSTS_PAGER'
export const SET_ADMIN_POSTS_PAGER_LAST_INDEX = 'SET_ADMIN_POSTS_PAGER_LAST_INDEX'
export const SET_ADMIN_POSTS_PAGER_PARAMS = 'SET_ADMIN_POSTS_PAGER_PARAMS'
export const PUSH_ITEM_TO_ADMIN_SHORTEN_URLS_PAGER_KEYS = 'PUSH_ITEM_TO_ADMIN_SHORTEN_URLS_PAGER_KEYS'
export const RESET_ADMIN_SHORTEN_URLS_PAGER = 'RESET_ADMIN_SHORTEN_URLS_PAGER'
export const SET_ADMIN_SHORTEN_URLS_PAGER_LAST_INDEX = 'SET_ADMIN_SHORTEN_URLS_PAGER_LAST_INDEX'
//export const AUTH_SET_USER = 'AUTH_SET_USER'
//export const AUTH_UPDATE_USER_INFO = 'AUTH_UPDATE_USER_INFO'
//export const AUTH_SET_TOKEN = 'AUTH_SET_TOKEN'
//export const AUTH_UPDATE_STATE = 'AUTH_UPDATE_STATE'

